<button #expandButton class="btn btn-link cx-action-link" (click)="triggerZoom()">
  <span>
    Zoom imagen
    <cx-icon [type]="iconType.EXPAND_ARROWS"></cx-icon
  ></span>
</button>
